import { options } from "@/global/slick-options";
import { get, getAll } from "PARENT/utilities/querySelector.js";

getAll(".image-and-content-slider").forEach((section) => {
    const images = get("[data-images]", section);
    const contents = get("[data-contents]", section);

    jQuery(images).slick({
        ...options,
        infinite: true,
        slidesToShow: 1,
        arrows: false,
        asNavFor: contents,
        fade: true,
    });
    jQuery(contents).slick({
        ...options,
        infinite: true,
        fade: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: images,
    });
});
